/**
 * Check if a node is an HTMLElement with cross-realm support
 * (e.g. if node is part of an iframe or a different document)
 */
function isHTMLElement(node) {
  var _node$ownerDocument, _node$ownerDocument$d;
  if (!node) return false;
  const htmlElement = ((_node$ownerDocument = node.ownerDocument) === null || _node$ownerDocument === void 0 ? void 0 : (_node$ownerDocument$d = _node$ownerDocument.defaultView) === null || _node$ownerDocument$d === void 0 ? void 0 : _node$ownerDocument$d.HTMLElement) || HTMLElement;
  return node instanceof htmlElement;
}

/**
 * Check if a node is an SVGElement with cross-realm support
 * (e.g. if node is part of an iframe or a different document)
 */
function isSVGElement(node) {
  var _node$ownerDocument2, _node$ownerDocument2$;
  if (!node) return false;
  const svgElement = ((_node$ownerDocument2 = node.ownerDocument) === null || _node$ownerDocument2 === void 0 ? void 0 : (_node$ownerDocument2$ = _node$ownerDocument2.defaultView) === null || _node$ownerDocument2$ === void 0 ? void 0 : _node$ownerDocument2$.SVGElement) || SVGElement;
  return node instanceof svgElement;
}

export { isHTMLElement, isSVGElement };
